import type { IHoliday } from "./IHoliday";

export class HolidayFunctions {
    public static formatHolidayDates(holiday: IHoliday) {
        const dateFormat = "L";
        if (holiday.dtStop.diff(holiday.dtStart, "hours") === 0) {
            return holiday.dtStart.format(dateFormat);
        }
        return `${holiday.dtStart.format(dateFormat)} - ${holiday.dtStop.format(dateFormat)}`;
    }
}
